import styled from 'styled-components';

import { Button, Divider } from 'components';

export const StyledDivider = styled(Divider)`
  margin: 15px 0 0 0;
`;

export const StyledFooterButton = styled(Button)<{ $isLgSize?: boolean }>`
  border-radius: 2px;
  font-weight: normal;
  ${({ $isLgSize }) => $isLgSize && 'width: 100%'}
`;

/**
 * work-around for the tooltip not disappearing problem,
 * wrap the button with this if tooltip does not go away
 * this is a known issue for tooltip:
 * https://github.com/react-component/tooltip/issues/18
 */
export const StyledTooltipButtonWrapper = styled.span`
  position: relative; // don't remove this line, the tooltip trigger will break on iOS safari without this.
  cursor: not-allowed;
  & > ${Button}:disabled {
    pointer-events: none;
  }
`;
